import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { rolesQuery } from '@/api/queries'
import { useCompanyCaller } from '@/app/company'
import { NothingForRole } from '@/app/nothing-for-role'
import { RoleEditor } from '@/app/role-editor'
import { canBuildRoles } from '@/domain/abilities'
import { t } from '@/i18n'
import { LoadingBlock } from '@/ui/spinner'

export const Route = createFileRoute('/_app/c/$orgId/roles/new')({
  /// `?from=<roleId>` — «Копіювати»: the builder opens on a copy. A copy is
  /// a GET + POST in the panel, not an endpoint (specs/roles.md, stage 2).
  validateSearch: (search: Record<string, unknown>): { from?: string } =>
    typeof search['from'] === 'string' ? { from: search['from'] } : {},
  component: NewRole,
})

function NewRole() {
  const { orgId } = Route.useParams()
  const { from } = Route.useSearch()
  const { caller } = useCompanyCaller(orgId)
  const roles = useQuery({ ...rolesQuery(orgId), enabled: Boolean(from) })

  if (!canBuildRoles(caller)) return <NothingForRole />
  if (from && roles.isPending) return <LoadingBlock label={t.app.loading} />

  const source = from ? (roles.data?.find((r) => r.id === from) ?? null) : null
  return <RoleEditor key={from ?? 'blank'} orgId={orgId} caller={caller} mode={{ kind: 'new', from: source }} />
}
